<template>
  <div>
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        {{ $t("Стадии проекта НПА") }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          :nudge-width="200"
          offset-y
        >
          <template v-slot:activator="{ on }">
            <a v-on="on">{{ $t("Все стадии") }}</a>
          </template>
          <v-list dense>
            <v-subheader>{{ $t("Все стадии") }}</v-subheader>
            <v-list-item
              v-for="stage in npaStages"
              :key="stage.id"
              two-line>
              <v-list-item-content>
                <v-list-item-title>{{ stage.npa_stages.transName }}</v-list-item-title>
                <v-list-item-subtitle>
                  {{ new Date(stage.date) | dateFormat('DD.MM.YYYY') }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-form
          action
          @submit.prevent="save"
        >
          <div
            class="form-group"
            :class="{invalid: $v.npaStage.npaStages.$dirty && !$v.npaStage.npaStages.required}"
          >
            <label>
              {{ $t("Стадия") }}
              <span class="asterix">*</span>
            </label>
            <v-select
              @input="$v.npaStage.npaStages.$touch()"
              @blur="$v.npaStage.npaStages.$touch()"
              :items="refNpaStages"
              item-value="id"
              item-text="transName"
              v-model="npaStage.npaStages"
              required
              outlined
              rounded
              dense
            />
          </div>
          <div
            class="form-group"
            :class="{invalid: $v.npaStage.date.$dirty && !$v.npaStage.date.required}"
          >
            <label>
              {{ $t("Дата") }}
              <span class="asterix">*</span>
            </label>
            <v-menu
              v-model="menuDate"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="npaStage.date"
                  readonly
                  v-on="on"
                  outlined
                  rounded
                  dense
                  @input="$v.npaStage.date.$touch()"
                  @blur="$v.npaStage.date.$touch()"
                />
              </template>
              <v-date-picker
                v-model="npaStage.date"
                :weekday-format="getDay"
                :month-format="getMonthFormat"
                :header-date-format="getHeaderDateFormat"
                no-title
                first-day-of-week="1"
              />
            </v-menu>
          </div>
          <div class="form-group">
            <label>
              {{ $t("Стадия") }}
            </label>
            <v-textarea
              outlined
              auto-grow
              rounded
              rows="1"
              v-model="npaStage.note"
              @input="$v.npaStage.note.$touch()"
              @blur="$v.npaStage.note.$touch()"
              full-width
              class="complaint-form-text"
            />
          </div>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="save">{{ $t("Сохранить") }}</v-btn>
        <v-btn @click="cancel">{{ $t("Отмена") }}</v-btn>
      </v-card-actions>
    </v-card>
    <v-overlay absolute :value="loading">
      <v-progress-circular indeterminate size="64"/>
    </v-overlay>
  </div>
</template>

<script>
  import Npa from '@/model/npa'
  import { required } from 'vuelidate/lib/validators'
  import mixin from '@/plugins/mixin/mixin'

  export default {
    mixins: [mixin],
    props: {
      npa: Object

    },
    data: () => ({
      refNpaStages: null,
      npaStage: {},
      menuDate: null,
      loading: false,
      npaStages: null,
      menu: false
    }),
    validations: {
      npaStage: {
        npaStages: { required },
        date: { required },
        note: {}
      }
    },
    methods: {
      cancel () {
        this.$emit('cancel')
      },
      save () {
        this.$v.$touch()

        if (this.$v.$invalid) {
          return
        }

        this.loading = true
        Npa.saveNpaStage(this.npa.id, { npa_stage: this.npaStage }).then((response) => {
          this.loading = false,
          this.npaStages = response.data.npaStages
          this.npaStage = {}
          this.$emit('save')
        })
      }
    },
    async mounted () {
      Npa.getNpaStageData(this.npa.id).then((response) => {
        this.refNpaStages = response.data.refNpaStages
        this.npaStages = response.data.npaStages
      })
    }
  }
</script>
